if (!customElements.get('popular-collection-filters')) {
  class PopularCollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.viewport = this.querySelector('[data-popular-filters-viewport]');
      this.list = this.querySelector('[data-popular-filters-list]');
      this.controls = this.querySelector('[data-popular-filters-controls]');
      this.previousButton = this.querySelector('[data-popular-filters-previous]');
      this.nextButton = this.querySelector('[data-popular-filters-next]');

      if (!this.viewport || !this.list || !this.controls || !this.previousButton || !this.nextButton) return;

      this.onPrevious = () => this.scrollByDirection(-1);
      this.onNext = () => this.scrollByDirection(1);
      this.onViewportScroll = () => this.requestUpdate();
      this.onWindowResize = () => this.requestUpdate();

      this.previousButton.addEventListener('click', this.onPrevious);
      this.nextButton.addEventListener('click', this.onNext);
      this.viewport.addEventListener('scroll', this.onViewportScroll, { passive: true });

      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.list);
      } else {
        window.addEventListener('resize', this.onWindowResize, { passive: true });
      }

      this.requestUpdate();
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.viewport?.removeEventListener('scroll', this.onViewportScroll);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.onWindowResize);

      if (this.updateFrame) window.cancelAnimationFrame(this.updateFrame);
      this.initialized = false;
    }

    requestUpdate() {
      if (this.updateFrame) return;

      this.updateFrame = window.requestAnimationFrame(() => {
        this.updateFrame = 0;
        this.updateControls();
      });
    }

    scrollByDirection(direction) {
      const firstItem = this.list.querySelector('.popular-collection-filters__item');
      if (!firstItem) return;

      const listStyles = window.getComputedStyle(this.list);
      const gap = Number.parseFloat(listStyles.columnGap || listStyles.gap || '0') || 0;
      const itemStep = firstItem.getBoundingClientRect().width + gap;
      const visibleItems = Math.max(1, Math.floor(this.viewport.clientWidth / itemStep));
      const distance = itemStep * Math.max(1, visibleItems - 1);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.viewport.scrollBy({
        left: direction * distance,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const currentScroll = Math.max(0, this.viewport.scrollLeft);
      const hasOverflow = maxScroll > 2;

      this.controls.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || currentScroll <= 2;
      this.nextButton.disabled = !hasOverflow || currentScroll >= maxScroll - 2;
    }
  }

  customElements.define('popular-collection-filters', PopularCollectionFilters);
}
